import VisibilityIcon from '@mui/icons-material/Visibility';
import React, { useEffect, useState } from 'react';
import { getSortState, Translate } from 'react-jhipster';
import { RouteComponentProps } from 'react-router-dom';

import { Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { NoData } from 'app/shared/components/no-data/NoData';
import { PageHeader } from 'app/shared/components/page-header/PageHeader';
import { PaginationComponent } from 'app/shared/components/pagination/Pagination';
import { SchedulingDetailModal } from 'app/shared/components/schedulingModal/SchedulingDetailModal';
import { TableComponent } from 'app/shared/components/table-component/TableComponent';
import { IHeaderItem } from 'app/shared/interfaces/headerItemsInterface';
import { IListData } from 'app/shared/interfaces/listDataInterface';
import { convertDateTimeToPtBR } from 'app/shared/util/date-utils';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { Loading } from 'app/shared/util/loading';
import { ASC, DEFAULT_ITEMS_PER_PAGE, DESC, SORT } from 'app/shared/util/pagination.constants';
import { getEntitiesByScheduling } from './gas-supply.reducer';

export const GasSupply = (props: RouteComponentProps<{ id: string; schedulingId: string }>) => {
  const dispatch = useAppDispatch();
  const gasSupplyList = useAppSelector(state => state.gasSupply.entities);
  const loadingGasSupply = useAppSelector(state => state.gasSupply.loading);

  const loading = useAppSelector(state => state.schedulingHistory.loading);
  const totalItems = useAppSelector(state => state.schedulingHistory.totalItems);
  const { match } = props;
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, DEFAULT_ITEMS_PER_PAGE, 'id'), props.location.search)
  );
  const [modalOpen, setModalOpen] = useState(false);

  const getAllEntities = () => {
    dispatch(
      getEntitiesByScheduling({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
        schedulingId: props.match.params.schedulingId,
      })
    );
  };

  useEffect(() => {
    if (!loadingGasSupply) {
      sortEntities();
    }
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [props.location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const formattedGasSupplyList = gasSupplyList.map(gasSupply => ({
    ...gasSupply,
    scheduling: gasSupply.scheduling
      ? {
          ...gasSupply.scheduling,
          startTime: gasSupply.scheduling.startTime ? convertDateTimeToPtBR(gasSupply.scheduling.startTime) : null,
          endTime: gasSupply.scheduling.endTime ? convertDateTimeToPtBR(gasSupply.scheduling.endTime) : null,
        }
      : null,
  }));

  const groupButtonIcons = [
    {
      icon: <VisibilityIcon color="secondary" />,
      path: '',
    },
  ];

  const headers: IHeaderItem[] = [
    { key: 'gasSupplyId', sortable: false, component: <Translate contentKey="fleetSenseApp.gasSupply.id" /> },
    { key: 'gasSupplyCreatedBy', sortable: false, component: <Translate contentKey="fleetSenseApp.gasSupply.createdBy" /> },
    { key: 'gasSupplyDistance', sortable: false, component: <Translate contentKey="fleetSenseApp.gasSupply.distance" /> },
    { key: 'gasSupplyVolume', sortable: false, component: <Translate contentKey="fleetSenseApp.gasSupply.volume" /> },
    { key: 'gasSupplyPrice', sortable: false, component: <Translate contentKey="fleetSenseApp.gasSupply.price" /> },
    { key: 'gasSupplyImage', sortable: false, component: <Translate contentKey="fleetSenseApp.gasSupply.image" /> },
  ];

  const data: IListData[] = [
    { type: 'text', value: 'id' },
    { type: 'text', value: 'createdBy' },
    { type: 'text', value: 'distance' },
    { type: 'text', value: 'volume' },
    { type: 'text', value: 'price' },
    { type: 'image', value: 'image' },

    { type: 'viewButton' },
    { type: 'editButton', value: 'id' },
    { type: 'deleteButton', value: 'id' },
  ];
  const handleClose = () => {
    props.history.push(`/scheduling`);
  };

  return (
    <Box sx={{ backgroundColor: 'primary.main', borderRadius: '8px', paddingTop: '16px', textAlign: 'center', padding: '24px' }}>
      <PageHeader
        onBackClick={() => handleClose()}
        headingId="gasSupply-heading"
        headingDataCy="gasSupplyHeading"
        contentKey="fleetSenseApp.gasSupply.home.title"
        buttonTextKey="fleetSenseApp.gasSupply.home.createLabel"
        showButton={true}
        match={match}
      />
      {!loading && !!formattedGasSupplyList?.length && (
        <TableComponent
          listData={data}
          headers={headers}
          list={formattedGasSupplyList}
          match={match}
          sortFunction={sort}
          pagination={paginationState}
          groupButtonIcons={groupButtonIcons}
          setSelect={setModalOpen}
        />
      )}

      {!loading && !formattedGasSupplyList.length && <NoData />}
      {modalOpen && <SchedulingDetailModal props={props} modalOpen={modalOpen} setModalOpen={setModalOpen}></SchedulingDetailModal>}
      {loading && <Loading />}
      <PaginationComponent paginationState={paginationState} totalItems={totalItems} onChange={handlePagination} list={formattedGasSupplyList} />
    </Box>
  );
};

export default GasSupply;
